import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

function Switch({
  className,
  size = "default",
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: "default" | "large";
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "group/switch relative inline-flex shrink-0 items-center rounded-full transition-all outline-none inset-border-normal",
        "focus-visible:ring-2 focus-visible:ring-primary-normal/50",
        "disabled:cursor-not-allowed",
        // Unchecked state — 시안은 7%(fills-primary). 2%(fills-light)는 흰 배경과 구분이 안 됐다
        "data-[state=unchecked]:bg-fills-primary",
        // Unchecked + 비활성 — 트랙을 중립 회색으로 갈아 끼워 "지금은 못 켠다"를 드러낸다 (시안)
        "data-[state=unchecked]:disabled:bg-fills-neutral",
        // Checked state - gradient background
        "data-[state=checked]:bg-linear-to-r data-[state=checked]:from-[#00ab78] data-[state=checked]:to-[#00cab2]",
        // 비활성은 전체 opacity 대신 검정 10% 딤 — 켜짐/꺼짐 대비를 유지한 채 어두워진다 (시안)
        "disabled:after:absolute disabled:after:inset-0 disabled:after:rounded-full disabled:after:bg-static-black/10 disabled:after:content-['']",
        // Size variants
        "data-[size=default]:h-6 data-[size=default]:w-12",
        "data-[size=large]:h-8 data-[size=large]:w-16",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          // 썸은 흰 원 + 이중 내부 테두리 (시안). 드롭섀도는 시안에 없다
          "pointer-events-none block rounded-full bg-white inset-border-double transition-all",
          // Size variants for thumb
          "group-data-[size=default]/switch:size-5",
          "group-data-[size=large]/switch:size-6",
          // Position based on state
          "group-data-[size=default]/switch:data-[state=unchecked]:translate-x-0.5",
          "group-data-[size=large]/switch:data-[state=unchecked]:translate-x-1",
          "group-data-[size=default]/switch:data-[state=checked]:translate-x-6.5",
          "group-data-[size=large]/switch:data-[state=checked]:translate-x-9",
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
